import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  de: {
    translation: {
      app_name: 'PedalScot',
      tagline: 'Entdecke Schottland auf zwei Rädern',
      nav: {
        routes: 'Routen',
        pois: 'Sehenswürdigkeiten',
        charging: 'Ladestationen',
        map: 'Karte',
        guide: 'Reise-Guide',
        community: 'Community',
        profile: 'Profil',
        events: 'Events',
        knowledge: 'Wissen',
        feedback: 'Feedback'
      },
      home: {
        hero_title: 'Die ultimative Fahrrad-Touristik-App für Schottland',
        hero_subtitle: 'Entdecke über 100 kuratierte Radwege durch die schottischen Highlands, finde E-Bike Ladestationen und erlebe unvergessliche Abenteuer auf zwei Rädern.',
        discover_routes: 'Routen entdecken',
        open_map: 'Karte öffnen',
        features_title: 'Warum PedalScot?',
        feature1_title: 'Premium-Routen',
        feature1_desc: '600+ kuratierte Routen durch Highlands, Islands & mehr',
        feature2_title: 'E-Bike Support',
        feature2_desc: 'Ladestationen & Reichweiten-Rechner',
        feature3_title: 'Points of Interest',
        feature3_desc: 'Burgen, Destillerien, Aussichtspunkte & mehr',
        feature4_title: 'Community',
        feature4_desc: 'Bewertungen, Tipps & Erfahrungen von Radfahrern',
        activities_title: 'Wähle dein Abenteuer',
        activities_subtitle: 'Ob Radfahren, Wandern oder Roadtrip – Schottland bietet für jeden das passende Abenteuer!',
        activity_cycling_title: '🚴 Radfahren',
        activity_cycling_desc: '600+ Radrouten von entspannten Küstentouren bis zu anspruchsvollen Mountain-Trails',
        activity_hiking_title: '🥾 Wandern',
        activity_hiking_desc: 'Entdecke Munros, Glens und spektakuläre Wanderwege durch die schottischen Highlands',
        activity_roadtrip_title: '🚗 Roadtrips',
        activity_roadtrip_desc: 'Fahre auf legendären Panoramastraßen wie der North Coast 500 und Isle of Skye',
        explore_routes: 'Routen erkunden',
        regions_title: 'Entdecke Schottlands Regionen',
        region_highlands_desc: 'Dramatische Berge und endlose Weite',
        region_islands_desc: 'Skye, Hebrides und mehr',
        region_cities_desc: 'Edinburgh, Glasgow, Inverness',
        region_borders_desc: 'Sanfte Hügel und historische Trails',
        ebike_tools_title: 'E-Bike Tools',
        charging_stations_title: 'Ladestationen',
        charging_stations_desc: 'Finde E-Bike Ladestationen in ganz Schottland',
        show_charging_stations: 'Ladestationen anzeigen',
        cta_title: 'Bereit für dein schottisches Abenteuer?',
        cta_subtitle: 'Erstelle ein kostenloses Konto und plane deine perfekte Radtour durch Schottland',
        cta_button: 'Jetzt kostenlos registrieren',
        guide_title: 'Schottland-Guide für Radfahrer',
        guide_subtitle: 'Alles, was du für deine Radtour in Schottland wissen musst',
        guide_overview: 'Überblick',
        guide_rules: 'Recht & Regeln',
        guide_safety: 'Sicherheit & Gesundheit',
        guide_weather: 'Wetter & Midges',
        guide_transport: 'Transport mit Rad',
        guide_charging: 'Laden & Reichweite',
        guide_camping: 'Wildcampen & Bothies',
        guide_routes: 'Top-Routen',
        guide_equipment: 'Ausrüstung & Setup',
        guide_accommodation: 'Unterkünfte',
        guide_tip: 'Tipp: Fähren (CalMac/NorthLink) und ScotRail-Radplätze früh reservieren. Wetterfenster und Midge-Prognose vor jeder Tour prüfen!',
        story_title: 'Von einem Radfahrer für Radfahrer',
        story_intro: 'Schottland hat mich nicht mehr losgelassen. Nach mehreren Besuchen in Edinburgh, den Highlands und auf den Inseln war klar: Ich muss dieses Land intensiver erleben. Also wanderte ich den Great Glen Way – durch einsame Täler, entlang des Caledonia Canals, umgeben von der rauen Schönheit der Highlands. Doch das reichte mir nicht. Also kam die große Radtour: Über 3.500km von den Orkney Islands quer durch Schottland. Wildcamping an Lochs, steile Anstiege, Gegenwind, Midges, und magische Sonnenuntergänge über dem Atlantik.',
        story_problem: 'Beide Male war die Planung ein Chaos – dutzende Websites, widersprüchliche Infos, keine zentrale Quelle. Diese App ist die, die ich damals gebraucht hätte.',
        story_solution: 'Alles, was hier drin ist, habe ich selbst erlebt – zu Fuß und auf dem Rad:',
        story_includes_title: 'Was du hier findest:',
        story_item1: 'Die Werkstätten, die mich gerettet haben',
        story_item2: 'Die Wildcamping-Spots, die ich gefunden habe',
        story_item3: 'Die Routen, die ich gewandert und gefahren bin',
        story_item4: 'Die Fehler, die ihr nicht machen müsst',
        story_closing: 'PedalScot ist mein Geschenk an die Radfahrer-Community – und an alle, die Schottland aktiv erleben wollen.',
        stats_routes: 'Routen',
        stats_pois: 'Points of Interest',
        stats_users: 'Aktive Nutzer',
        premium_badge: 'Premium'
      },
      filters: {
        all: 'Alle',
        activity_type: 'Aktivität',
        region: 'Region',
        difficulty: 'Schwierigkeit',
        bike_type: 'Fahrradtyp',
        route_type: 'Routentyp',
        clear: 'Filter löschen'
      },
      activities: {
        cycling: 'Radfahren',
        hiking: 'Wandern',
        roadtrip: 'Roadtrip'
      },
      regions: {
        Highlands: 'Highlands',
        Islands: 'Inseln',
        Borders: 'Borders',
        Cities: 'Städte'
      },
      difficulties: {
        easy: 'Leicht',
        moderate: 'Mittel',
        hard: 'Schwer',
        expert: 'Experte'
      },
      bike_types: {
        all: 'Alle',
        normal: 'Normal',
        ebike: 'E-Bike',
        mountain: 'Mountainbike'
      },
      route_types: {
        road: 'Straße',
        gravel: 'Schotter',
        mountain: 'Berg',
        mixed: 'Gemischt'
      },
      categories: {
        culture: 'Kultur & Geschichte',
        nature: 'Natur & Landschaft',
        food: 'Genuss',
        whisky: 'Whisky-Destillerien',
        tour_operators: 'Tour-Veranstalter',
        infrastructure: 'Infrastruktur',
        accommodation: 'Unterkunft'
      },
      route: {
        distance: 'Distanz',
        elevation: 'Höhenmeter',
        duration: 'Dauer',
        hours: 'Std.',
        view_details: 'Details anzeigen',
        verified: 'Verifiziert'
      },
      poi: {
        rating: 'Bewertung',
        bike_friendly: 'Fahrradfreundlich',
        opening_hours: 'Öffnungszeiten',
        phone: 'Telefon',
        website: 'Webseite'
      },
      loading: 'Lädt...',
      error: 'Fehler beim Laden',
      no_data: 'Keine Daten verfügbar',
      auth: {
        login: 'Anmelden',
        logout: 'Abmelden',
        register: 'Registrieren',
        login_subtitle: 'Melde dich an, um alle Features zu nutzen',
        register_subtitle: 'Erstelle einen kostenlosen Account',
        email: 'E-Mail',
        password: 'Passwort',
        confirm_password: 'Passwort bestätigen',
        name: 'Name',
        logging_in: 'Wird angemeldet...',
        registering: 'Wird registriert...',
        no_account: 'Noch kein Account?',
        have_account: 'Bereits einen Account?',
        register_now: 'Jetzt registrieren',
        login_now: 'Jetzt anmelden',
        premium_required: 'Premium-Mitgliedschaft erforderlich',
        upgrade_to_premium: 'Auf Premium upgraden',
        forgot_password: 'Passwort vergessen?',
        password_mismatch: 'Passwörter stimmen nicht überein',
        password_too_short: 'Passwort muss mindestens 6 Zeichen lang sein',
        upgrade_failed: 'Upgrade fehlgeschlagen',
        image_only: 'Bitte wähle ein Bild aus (JPEG, PNG oder WebP)',
        file_too_large: 'Das Bild darf maximal 5MB groß sein',
        upload_error: 'Fehler beim Hochladen des Profilbilds'
      },
      profile: {
        title: 'Profil',
        subtitle: 'Deine Statistiken und Erfolge',
        premium_member: 'Premium Mitglied',
        free_account: 'Free Account',
        upgrade_title: 'Upgrade auf Premium',
        upgrade_desc: 'Schalte alle Features frei:',
        upgrade_feature1: 'Unbegrenzter Zugriff auf alle 100+ Routen',
        upgrade_feature2: 'Eigene Routen erstellen',
        upgrade_feature3: 'Fotos in Bewertungen hochladen',
        upgrade_feature4: '7-Tage Wettervorhersage',
        upgrade_feature5: 'Prioritäts-Support',
        upgrade_button: 'Jetzt kostenlos upgraden (Demo)',
        upgrading: 'Wird aktualisiert...',
        upgrade_success: 'Premium erfolgreich aktiviert!',
        total_distance: 'Gesamtstrecke',
        total_elevation: 'Höhenmeter',
        total_rides: 'Touren',
        achievements: 'Erfolge',
        first_tour: 'Erste Tour',
        completed: 'Abgeschlossen',
        reached: 'Erreicht!',
        demo_mode: 'Demo-Modus: Dies ist ein Demo-Profil. In der Vollversion kannst du deine echten Touren tracken und synchronisieren.'
      },
      routes: {
        title: 'Routen',
        subtitle: 'Entdecke die besten Radwege Schottlands',
        create_route: 'Eigene Route erstellen',
        filter_show: 'Filter anzeigen',
        filter_hide: 'Filter verbergen',
        clear_filters: 'Filter löschen',
        limited_warning_title: 'Nur 10 Routen verfügbar (Free Version)',
        limited_warning_text: 'Upgrade auf Premium für unbegrenzten Zugriff auf alle 100+ Routen!',
        upgrade_now: 'Jetzt upgraden',
        distance_label: 'Distanz',
        elevation_label: 'Höhenmeter',
        show_on_map: 'Auf Karte anzeigen',
        routes_found: 'Routen gefunden',
        no_routes: 'Keine Routen gefunden',
        verified: 'Verifiziert',
        child_friendly: 'Kindergeeignet',
        child_friendly_only: 'Nur kindergeeignete Routen'
      },
      pois: {
        title: 'Sehenswürdigkeiten',
        subtitle: 'Entdecke interessante Orte entlang deiner Route',
        show_on_map: 'Auf Karte anzeigen',
        pois_found: 'POIs gefunden',
        no_pois: 'Keine POIs gefunden'
      },
      events: {
        title: 'Events',
        subtitle: 'Radveranstaltungen und Festivals in Schottland',
        upcoming_only: 'Nur zukünftige Events',
        all_events: 'Alle Events',
        events_found: 'Events gefunden',
        no_events: 'Keine Events gefunden',
        free_entry: 'Freier Eintritt',
        from: 'Ab'
      },
      map: {
        title: 'Karte',
        subtitle: 'Interaktive Karte von Schottland',
        show_regions: 'Regionen',
        show_routes: 'Routen',
        show_pois: 'POIs',
        legend: 'Legende'
      },
      create_route: {
        title: 'Route erstellen',
        subtitle: 'Erstelle deine eigene Route',
        route_name: 'Routenname',
        description: 'Beschreibung',
        distance: 'Distanz (km)',
        elevation: 'Höhenmeter (m)',
        duration: 'Dauer (Stunden)',
        save_route: 'Route speichern',
        cancel: 'Abbrechen',
        creating: 'Wird erstellt...'
      },
      my_routes: {
        title: 'Meine Routen',
        subtitle: 'Deine gespeicherten Routen',
        no_routes: 'Du hast noch keine Routen erstellt',
        create_first: 'Erstelle deine erste Route',
        delete: 'Löschen',
        edit: 'Bearbeiten'
      },
      pricing: {
        title: 'Premium werden',
        subtitle: 'Wähle den perfekten Plan für dein Schottland-Abenteuer',
        features_title: 'Was du mit Premium bekommst:',
        feature_1: 'Unbegrenzter Zugriff auf alle 100+ verifizierten Routen',
        feature_2: 'Eigene Routen erstellen und teilen',
        feature_3: 'Fotos in Bewertungen hochladen',
        feature_4: '7-Tage Wettervorhersage für alle Regionen',
        feature_5: 'Offline-Karten zum Download',
        feature_6: 'Prioritäts-Support',
        month: 'Monat',
        months: 'Monate',
        lifetime_label: 'Für immer',
        save: 'Spare',
        bestseller: 'Bestseller',
        early_bird: 'Early Bird',
        choose_plan: 'Plan wählen',
        current_plan: 'Aktueller Plan',
        upgrading: 'Wird aktiviert...',
        already_premium: 'Du bist bereits Premium-Mitglied!',
        upgrade_success: 'Premium erfolgreich aktiviert! 🎉',
        upgrade_failed: 'Upgrade fehlgeschlagen. Bitte versuche es erneut.',
        faq_title: 'Häufige Fragen',
        faq_1_q: 'Kann ich jederzeit kündigen?',
        faq_1_a: 'Ja, du kannst jederzeit kündigen. Dein Premium-Zugang bleibt bis zum Ende des bezahlten Zeitraums aktiv.',
        faq_2_q: 'Was passiert nach Ablauf meines Abos?',
        faq_2_a: 'Nach Ablauf kannst du die App weiterhin nutzen, aber mit eingeschränktem Zugriff (10 Routen). Du kannst jederzeit wieder Premium werden.',
        faq_3_q: 'Ist das Lifetime-Angebot wirklich für immer?',
        faq_3_a: 'Ja! Einmalzahlung, lebenslanger Zugriff auf alle Premium-Features. Das Early-Bird-Angebot ist nur für die ersten 500 Nutzer verfügbar.',
        demo_note: 'Demo-Modus: Dies ist eine Demo-Version. In der Vollversion würde hier die Zahlungsabwicklung (z.B. Stripe) integriert werden.'
      },
      payment: {
        processing: 'Zahlung wird verarbeitet...',
        success_title: 'Zahlung erfolgreich! 🎉',
        success_message: 'Willkommen bei PedalScot Premium! Dein Account wurde erfolgreich aufgewertet.',
        whats_next: 'Was jetzt möglich ist:',
        feature_unlocked_1: 'Alle 100+ Premium-Routen freigeschaltet',
        feature_unlocked_2: 'Erstelle und teile eigene Routen',
        feature_unlocked_3: 'Lade Fotos in Bewertungen hoch',
        feature_unlocked_4: '7-Tage Wettervorhersage verfügbar',
        go_to_profile: 'Zu meinem Profil',
        confirmation_email: 'Eine Bestätigungs-Email wurde an deine Adresse gesendet.'
      },
      knowledge: {
        title: 'Wissen',
        subtitle: 'Alles für deine perfekte Schottland-Tour',
        all: 'Alle',
        guides: 'Ratgeber',
        regions: 'Regionen',
        checklists: 'Checklisten',
        stories: 'Stories',
        learn_more: 'Mehr erfahren',
        download_pdf: 'PDF herunterladen',
        guide_equipment: 'Ausrüstung für Radtouren',
        guide_equipment_desc: 'Alles was du für deine Schottland-Tour brauchst',
        guide_technique: 'Fahrtechnik',
        guide_technique_desc: 'Tipps für Anfänger und Fortgeschrittene',
        guide_safety: 'Sicherheit',
        guide_safety_desc: 'Sicher unterwegs in Schottland',
        guide_traffic: 'Verkehrsregeln UK',
        guide_traffic_desc: 'Linksverkehr und schottische Besonderheiten',
        guide_ebike: 'E-Bike Basics',
        guide_ebike_desc: '25 km/h und 45 km/h - Was du wissen musst',
        region_highlands: 'Highlands',
        region_highlands_desc: 'Dramatische Berglandschaften und NC500',
        region_islands: 'Islands (Skye, Orkney, Shetland)',
        region_islands_desc: 'Inselabenteuer mit Fähren & extremem Wind',
        region_lowlands: 'Lowlands & Borders',
        region_lowlands_desc: 'Sanfte Hügel und historische Stätten',
        region_edinburgh: 'Edinburgh & Fife',
        region_edinburgh_desc: 'Hauptstadt und Küstenrouten',
        season_may_sep: 'Mai - September',
        season_jun_aug: 'Juni - August',
        season_apr_oct: 'April - Oktober',
        season_year_round: 'Ganzjährig',
        checklist_packing: 'Packliste Mehrtagestouren',
        checklist_packing_desc: 'Vollständige Liste für 3-7 Tage Touren',
        checklist_bike: 'Fahrrad-Check vor der Tour',
        checklist_bike_desc: 'Sicherheitsprüfung in 10 Schritten',
        checklist_emergency: 'Notfall-Checkliste',
        checklist_emergency_desc: 'Wichtige Nummern und Erste Hilfe',
        story_nc500: 'NC500 in 10 Tagen',
        story_nc500_desc: '850 km durch die schönsten Highlands',
        story_skye: 'Isle of Skye mit dem E-Bike',
        story_skye_desc: 'Magische Insel ohne Schweißausbrüche',
        story_whisky: 'Whisky Trail per Rad',
        story_whisky_desc: 'Speyside-Destillerien mit dem Bike',
        stats_guides: 'Ratgeber',
        stats_regions: 'Regionen',
        stats_checklists: 'Checklisten',
        stats_stories: 'Stories'
      },
      calculator: {
        title: 'E-Bike Reichweiten-Rechner',
        battery_capacity: 'Akku-Kapazität (kWh)',
        current_charge: 'Aktueller Ladestand (%)',
        elevation: 'Höhenmeter (m)',
        wind_speed: 'Windgeschwindigkeit (km/h)',
        rider_weight: 'Fahrergewicht (kg)',
        assistance_level: 'Unterstützungsstufe (1-3)',
        calculate: 'Reichweite berechnen',
        calculating: 'Berechne...',
        result_title: 'Ergebnis',
        estimated_range: 'Geschätzte Reichweite',
        can_complete: 'Route schaffbar',
        cannot_complete: 'Route zu lang für aktuelle Ladung',
        remaining_charge: 'Verbleibende Ladung',
        yes: 'Ja',
        no: 'Nein',
        warning: 'Warnung',
        charging_needed: 'Ladung benötigt'
      },
      guide: {
        page_title: 'Schottland-Guide für Radfahrer',
        page_subtitle: 'Alles, was du für deine Radtour in Schottland wissen musst',
        overview: {
          title: 'Überblick',
          important: 'Wichtig',
          drive_left: 'In Schottland fährt man links! Inseln, Pässe und Single-Track-Roads mit Ausweichbuchten sind typisch.',
          best_season_title: 'Beste Reisezeit',
          best_season_optimal: 'Mai–Juni und September–Oktober sind optimal',
          best_season_summer: 'Sommer ist wärmer, aber Midges sind aktiv',
          best_season_west: 'Westen ist nasser als Osten',
          best_season_wind: 'Wind kommt oft aus Südwest',
          tip: 'Tipp',
          tip_text: 'Plane Etappen gegen den Wind kürzer ein und kalkuliere Regen- und Windtage ein.'
        },
        legal: {
          title: 'Recht & Regeln',
          ebike_title: 'E-Bike Regulierung (EAPC)',
          ebike_power: 'Max. 250 W Motor',
          ebike_speed: 'Unterstützung bis 25 km/h',
          ebike_age: 'Ab 14 Jahren',
          ebike_license: 'Keine Zulassung oder Versicherung nötig',
          equipment_title: 'Pflichtausstattung',
          equipment_lights: 'Licht bei Dunkelheit: Vorne weiß, hinten rot',
          equipment_reflectors: 'Reflektoren: Roter Rückstrahler, Pedalreflektoren empfohlen',
          equipment_helmet: 'Helm: Nicht Pflicht, aber stark empfohlen',
          access_title: 'Scottish Outdoor Access Code',
          access_text: 'In Schottland hast du gesetzlich gesicherten Zugang zur Natur, wenn du dich rücksichtsvoll verhältst. Dies gilt auch fürs Rad!',
          access_link: 'Scottish Outdoor Access Code'
        },
        safety: {
          title: 'Sicherheit & Gesundheit',
          single_track_warning: 'Single-Track-Roads: Vorausschauend fahren, früh in Ausweichbuchten warten, Handzeichen geben und danken!',
          ticks_title: 'Zecken & Lyme-Borreliose',
          ticks_clothing: 'Lange Kleidung und Repellent verwenden',
          ticks_check: 'Täglicher Check nach Zecken',
          ticks_removal: 'Zecken korrekt mit Pinzette entfernen',
          ticks_symptoms: 'Bei Erythem oder Grippe-Symptomen sofort zum Arzt',
          emergency_title: 'Notruf',
          emergency_text: '999 oder 112 | Medizinische Beratung: NHS 24 über 111',
          traffic_title: 'Verkehrssicherheit',
          traffic_distance: 'Bus-/Lkw-Überholabstände beachten',
          traffic_lights: 'Nachts nur mit vollständiger Beleuchtung fahren',
          traffic_groups: 'In Gruppen: Zu zweit nebeneinander ist erlaubt, aber bei Bedarf einreihen'
        },
        weather: {
          title: 'Wetter & Midges',
          temp_title: 'Temperaturen & Klima',
          temp_warmest: 'Wärmste Monate: Juni–August',
          temp_east: 'Ostseite: Trockener und heller',
          temp_west: 'Westküste: Nasser, aber spektakulärer',
          midges_warning: 'Midges (Stechmücken):',
          midges_season: 'Hochsaison: Mai–September',
          midges_worst: 'Am schlimmsten bei windstillen Dämmerungen',
          midges_protection: 'Midge-Netz und Repellent mitnehmen!',
          midges_forecast: 'Scottish Midge Forecast'
        },
        transport: {
          title: 'Transport mit Rad',
          train_title: 'Zug (ScotRail)',
          train_bikes_free: 'Fahrräder meist gratis mit Reservierung',
          train_ebikes: 'E-Bikes erlaubt',
          train_scooters: 'E-Scooter verboten',
          train_booking: 'Kontingente je Zug – früh buchen!',
          ferry_title: 'Fähren',
          ferry_calmac: 'CalMac (Hebriden):',
          ferry_calmac_bikes: 'Räder werden mitgenommen',
          ferry_calmac_booking: 'Reservierung für Personenfahrten dringend empfohlen',
          ferry_calmac_spaces: 'Radplätze i.d.R. ausreichend',
          ferry_northlink: 'NorthLink (Orkney/Shetland):',
          ferry_northlink_booking: 'Radmitnahme möglich, vorher buchen',
          bus_title: 'Fernbus (Citylink/Stagecoach)',
          bus_storage: 'Räder teils im Gepäckraum',
          bus_sock: 'Oft "Bike-Sock"/Hülle nötig',
          bus_limited: 'Limitierte Plätze',
          bus_ebikes: 'E-Bikes meist ausgeschlossen – vorher prüfen!',
          flight_warning: 'Flug: E-Bike-Akkus (>160 Wh) dürfen nicht ins Passagierflugzeug. Lösung: E-Bike vor Ort mieten oder Akku separat per Gefahrgutfracht (aufwendig/teuer).'
        },
        charging: {
          title: 'Laden & Reichweite',
          public_title: 'Öffentliche Ladepunkte',
          public_text: 'Öffentliche E-Bike-Ladepunkte existieren punktuell, oft Bosch "PowerStations" an Cafés auf NCN-Routen. Nicht flächendeckend!',
          tips_title: 'Tipps:',
          tips_charger: 'Eigenes Ladegerät immer mitbringen',
          tips_accommodation: 'Unterkünfte vorab nach Lademöglichkeiten fragen',
          tips_plug: 'UK-Stecker (Typ G) besorgen',
          tips_powerbank: 'Powerbank für GPS/Licht',
          range_title: 'Reichweiten-Faktoren',
          range_cold: 'Kälte senkt Reichweite',
          range_wind: 'Wind kann Reichweite stark beeinflussen',
          range_terrain: 'Grober Untergrund erhöht Verbrauch',
          recommendation: 'Empfehlung: Plane "Eco"-Anteile ein und bring wenn möglich einen Pufferakku mit.'
        },
        camping: {
          title: 'Wildcampen & Bothies',
          wild_title: 'Wildcampen',
          wild_intro: 'Wildcampen mit Zelt in kleiner Zahl und nur 2–3 Nächte pro Platz ist erlaubt, wenn du:',
          wild_distance: 'Abstand zu Gebäuden/Weiden hältst',
          wild_trace: 'Spurlos gehst (Leave No Trace)',
          wild_code: 'Den Access Code befolgst',
          wild_fire: 'Feuer vermeidest',
          wild_trash: 'Müll mitnimmst',
          lomond_warning: 'Loch Lomond & The Trossachs: Saisonale Zonen mit Permit-Pflicht beachten!',
          bothies_title: 'Bothies (Schutzhütten)',
          bothies_intro: 'Bothies sind einfache Hütten für Not- und Schlechtwetter-Situationen. Befolge den "Bothy Code":',
          bothies_groups: 'Keine großen Gruppen',
          bothies_clean: 'Hütte sauber hinterlassen',
          bothies_respect: 'Respekt vor anderen Nutzern',
          bothies_no_booking: 'Keine Reservierungen möglich',
          bothies_link: 'Mountain Bothies Association'
        },
        routes: {
          title: 'Top-Routen',
          hebridean_title: 'Hebridean Way',
          hebridean_stats: '~300 km | Äußere Hebriden | Viele Fähren',
          hebridean_desc: 'Landschaft pur, wenig Verkehr, starker Wind. Rückenwind-Route (Nord→Süd) bevorzugen!',
          caledonia_title: 'The Caledonia Way (NCN 78)',
          caledonia_stats: 'Oban–Fort William–Inverness | Great Glen',
          caledonia_desc: 'Mischung aus ruhigen Straßen und Kanaltowpaths. E-Bike-freundlich und landschaftlich spektakulär.',
          deeside_title: 'Deeside Way (NCN 195)',
          deeside_stats: 'Aberdeen–Ballater | Alte Bahntrasse',
          deeside_desc: 'Familienfreundlich, flach, gut ausgebaut. Perfekt für Einsteiger.',
          speyside_title: 'Speyside Way',
          speyside_stats: 'Fochabers–Ballindalloch & Nethy Bridge–Aviemore',
          speyside_desc: 'Abschnitte radtauglich. Whisky-Brennereien entlang der Route!',
          mtb_title: 'MTB/Gravel-Zentren',
          mtb_glentress: 'Glentress/Innerleithen (Tweed Valley, 7stanes): Breites Trail-Spektrum',
          mtb_nevis: 'Nevis Range, Fort William: Gondel-Uplift, World-Cup-Downhill',
          mtb_7stanes: 'Weitere 7stanes: Kirroughtree, Ae, Mabie, Dalbeattie'
        },
        equipment: {
          title: 'Ausrüstung & Setup',
          tires_title: 'Reifen',
          tires_tour: 'Tour: 32–38 mm mit Pannenschutz',
          tires_gravel: 'Gravel/MTB: 40–50 mm+, robust',
          weather_title: 'Wetter-Ausrüstung',
          weather_jacket: '3-Lagen-Regenjacke (wasserdicht & atmungsaktiv)',
          weather_overshoes: 'Überschuhe',
          weather_gloves: 'Wasserdichte Handschuhe',
          weather_bags: 'Wechselkleidung in wasserdichten Packsäcken',
          electronics_title: 'Elektronik',
          electronics_lights: 'Fest montiertes Licht (vorne & hinten)',
          electronics_charger: 'USB-Lader + Powerbank',
          electronics_gps: 'GPS-Gerät oder Smartphone mit Offline-Karten',
          ebike_title: 'E-Bike spezifisch',
          ebike_charger: '4A-Lader mit UK-Stecker (Typ G)',
          ebike_cold: 'Akkuschutz bei Kälte',
          ebike_spare: 'Ggf. Zweitakku',
          ebike_insulation: 'Isolierhülle für Akku im Winter',
          health_title: 'Gesundheit',
          health_net: 'Midge-Netz',
          health_repellent: 'Repellent (DEET)',
          health_tick: 'Zeckenkarte/-pinzette',
          health_first_aid: 'Erste-Hilfe-Set'
        },
        accommodation: {
          title: 'Unterkünfte',
          hostels_title: 'Hostelling Scotland',
          hostels_intro: 'Häufig mit Fahrradraum, teils Bike-Wash und Trocknung. Beispiele:',
          hostels_oban: 'Oban',
          hostels_aviemore: 'Aviemore',
          hostels_port: 'Port Charlotte',
          hostels_lochranza: 'Lochranza',
          hostels_tip: 'Immer vorab Abstell- und Lade-Regeln klären!',
          networks_title: 'Netzwerke',
          networks_scottish: 'Scottish Hostels: "cycle friendly"-Filter',
          networks_independent: 'Independent Hostels: Fahrradfreundliche Unterkünfte',
          networks_bnb: 'B&Bs: Viele bieten Bike-Storage und Trocknung',
          hostels_link: 'Hostelling Scotland'
        },
        planning: {
          title: 'Planung & Buchung',
          accommodation_title: 'Übernachtung',
          accommodation_best: 'Beste Plattformen',
          hostelworld_title: 'Hostelworld',
          hostelworld_desc: 'Größte Auswahl, starke App, viele Reviews',
          hostelling_title: 'Hostelling Scotland',
          hostelling_desc: 'Landesweites Netz, Direktbuchung mit Bestpreis-Garantie',
          alternatives_title: 'Günstigere & fairere Alternativen',
          direct_booking_title: 'Direkt beim Haus buchen',
          direct_booking_desc: 'VisitScotland empfiehlt Direktbuchung – oft fairste Lösung für Betriebe. Link über Google Hotels finden und auf "Website" klicken.',
          hostelz_title: 'Hostelz.com',
          hostelz_desc: 'Preisvergleich ohne OTA-Bias. Zeigt Preise von Hostelworld, Booking u.a.',
          dorms_title: 'Dorms.com',
          dorms_desc: 'Zusätzliche Hostel-Option',
          booking_note: 'Hinweis: Booking.com arbeitet mit ~15% Kommission. Direktbuchung umgeht diese Kosten und unterstützt Betriebe direkt.',
          workflow_title: 'Praktische Vorgehensweise (3 Schritte)',
          workflow_step1: 'Auf Hostelworld filtern, Karte checken, Bewertungen lesen',
          workflow_step2: 'Objekt bei Hostelling Scotland bzw. via Google Hotels suchen und wenn möglich direkt buchen',
          workflow_step3: 'Preise kurz mit Hostelz.com querprüfen',
          workflow_result: 'Damit deckst du Auswahl, Preis und Fairness ab.',
          flights_title: 'Flüge',
          flights_best: 'Beste Flugsuchmaschinen',
          skyscanner_title: 'Skyscanner',
          skyscanner_desc: '"Everywhere"-Suche, Monatsansicht, Preis-Alerts',
          google_flights_title: 'Google Flights',
          google_flights_desc: 'Transparenz, Kalender, Preisverfolgung. Oft direkter Link zur Airline.',
          kayak_title: 'KAYAK & momondo',
          kayak_desc: 'Zusätzliche Metasuchen zum Quercheck',
          airlines_title: 'Direkt bei Airlines buchen',
          airlines_desc: 'Bessere Nachbetreuung und klare Gepäckregeln',
          airlines_list: 'Loganair, easyJet, Ryanair, British Airways',
          flights_workflow_title: 'Empfohlener Ablauf (3 Schritte)',
          flights_step1: 'In Skyscanner suchen, flexibel mit Monatsansicht/"Everywhere" spielen',
          flights_step2: 'Route in Google Flights gegenprüfen und Preisalarm setzen',
          flights_step3: 'Bei bester Option direkt bei Airline oder günstigster Plattform buchen',
          visit_website: 'Website besuchen'
        },
        footer_tip: 'Tipp: Fähren (CalMac/NorthLink) und ScotRail-Radplätze früh reservieren. Wetterfenster und Midge-Prognose vor jeder Tour prüfen!'
      }
    }
  },
  en: {
    translation: {
      app_name: 'PedalScot',
      tagline: 'Discover Scotland on Two Wheels',
      nav: {
        routes: 'Routes',
        pois: 'Points of Interest',
        charging: 'Charging Stations',
        map: 'Map',
        guide: 'Travel Guide',
        community: 'Community',
        profile: 'Profile',
        events: 'Events',
        knowledge: 'Knowledge',
        feedback: 'Feedback'
      },
      home: {
        hero_title: 'The Ultimate Cycling Tourism App for Scotland',
        hero_subtitle: 'Discover over 100 curated cycling routes through the Scottish Highlands, find E-Bike charging stations and experience unforgettable adventures on two wheels.',
        discover_routes: 'Discover Routes',
        open_map: 'Open Map',
        features_title: 'Why PedalScot?',
        feature1_title: 'Premium Routes',
        feature1_desc: '600+ curated routes through Highlands, Islands & more',
        feature2_title: 'E-Bike Support',
        feature2_desc: 'Charging stations & range calculator',
        feature3_title: 'Points of Interest',
        feature3_desc: 'Castles, distilleries, viewpoints & more',
        feature4_title: 'Community',
        feature4_desc: 'Reviews, tips & experiences from cyclists',
        activities_title: 'Choose Your Adventure',
        activities_subtitle: 'Whether cycling, hiking or roadtrip – Scotland offers the perfect adventure for everyone!',
        activity_cycling_title: '🚴 Cycling',
        activity_cycling_desc: '600+ cycling routes from relaxed coastal tours to challenging mountain trails',
        activity_hiking_title: '🥾 Hiking',
        activity_hiking_desc: 'Discover Munros, Glens and spectacular hiking trails through the Scottish Highlands',
        activity_roadtrip_title: '🚗 Roadtrips',
        activity_roadtrip_desc: 'Drive on legendary scenic roads like the North Coast 500 and Isle of Skye',
        explore_routes: 'Explore Routes',
        regions_title: 'Discover Scotland\'s Regions',
        region_highlands_desc: 'Dramatic mountains and endless expanses',
        region_islands_desc: 'Skye, Hebrides and more',
        region_cities_desc: 'Edinburgh, Glasgow, Inverness',
        region_borders_desc: 'Rolling hills and historic trails',
        ebike_tools_title: 'E-Bike Tools',
        charging_stations_title: 'Charging Stations',
        charging_stations_desc: 'Find E-Bike charging stations across Scotland',
        show_charging_stations: 'Show Charging Stations',
        cta_title: 'Ready for Your Scottish Adventure?',
        cta_subtitle: 'Create a free account and plan your perfect cycling tour through Scotland',
        cta_button: 'Register for Free',
        guide_title: 'Scotland Guide for Cyclists',
        guide_subtitle: 'Everything you need to know for your cycling tour in Scotland',
        guide_overview: 'Overview',
        guide_rules: 'Law & Rules',
        guide_safety: 'Safety & Health',
        guide_weather: 'Weather & Midges',
        guide_transport: 'Transport with Bike',
        guide_charging: 'Charging & Range',
        guide_camping: 'Wild Camping & Bothies',
        guide_routes: 'Top Routes',
        guide_equipment: 'Equipment & Setup',
        guide_accommodation: 'Accommodation',
        guide_tip: 'Tip: Book ferries (CalMac/NorthLink) and ScotRail bike spaces early. Check weather forecast and midge prediction before each tour!',
        story_title: 'From a Cyclist for Cyclists',
        story_intro: 'Scotland never let me go. After several visits to Edinburgh, the Highlands and the islands, one thing was clear: I need to experience this country more intensively. So I hiked the Great Glen Way – through lonely valleys, along the Caledonian Canal, surrounded by the rugged beauty of the Highlands. But that wasn\'t enough. Then came the big cycling tour: Over 3,500km from the Orkney Islands across Scotland. Wild camping by lochs, steep climbs, headwinds, midges, and magical sunsets over the Atlantic.',
        story_problem: 'Both times, planning was chaos – dozens of websites, contradictory information, no central source. This app is the one I needed back then.',
        story_solution: 'Everything in here, I experienced myself – on foot and by bike:',
        story_includes_title: 'What you\'ll find here:',
        story_item1: 'The bike shops that saved me',
        story_item2: 'The wild camping spots I discovered',
        story_item3: 'The routes I hiked and cycled',
        story_item4: 'The mistakes you don\'t need to make',
        story_closing: 'PedalScot is my gift to the cycling community – and to everyone who wants to experience Scotland actively.',
        stats_routes: 'Routes',
        stats_pois: 'Points of Interest',
        stats_users: 'Active Users',
        premium_badge: 'Premium'
      },
      filters: {
        all: 'All',
        activity_type: 'Activity',
        region: 'Region',
        difficulty: 'Difficulty',
        bike_type: 'Bike Type',
        route_type: 'Route Type',
        clear: 'Clear Filters'
      },
      activities: {
        cycling: 'Cycling',
        hiking: 'Hiking',
        roadtrip: 'Roadtrip'
      },
      regions: {
        Highlands: 'Highlands',
        Islands: 'Islands',
        Borders: 'Borders',
        Cities: 'Cities'
      },
      difficulties: {
        easy: 'Easy',
        moderate: 'Moderate',
        hard: 'Hard',
        expert: 'Expert'
      },
      bike_types: {
        all: 'All',
        normal: 'Normal',
        ebike: 'E-Bike',
        mountain: 'Mountain Bike'
      },
      route_types: {
        road: 'Road',
        gravel: 'Gravel',
        mountain: 'Mountain',
        mixed: 'Mixed'
      },
      categories: {
        culture: 'Culture & History',
        nature: 'Nature & Landscape',
        food: 'Food & Drink',
        whisky: 'Whisky Distilleries',
        tour_operators: 'Tour Operators',
        infrastructure: 'Infrastructure',
        accommodation: 'Accommodation'
      },
      route: {
        distance: 'Distance',
        elevation: 'Elevation',
        duration: 'Duration',
        hours: 'hrs',
        view_details: 'View Details',
        verified: 'Verified'
      },
      poi: {
        rating: 'Rating',
        bike_friendly: 'Bike Friendly',
        opening_hours: 'Opening Hours',
        phone: 'Phone',
        website: 'Website',
        show_on_map: 'Show on Map'
      },
      loading: 'Loading...',
      error: 'Error loading data',
      no_data: 'No data available',
      auth: {
        login: 'Login',
        logout: 'Logout',
        register: 'Register',
        login_subtitle: 'Sign in to access all features',
        register_subtitle: 'Create a free account',
        email: 'Email',
        password: 'Password',
        confirm_password: 'Confirm Password',
        name: 'Name',
        logging_in: 'Logging in...',
        registering: 'Registering...',
        no_account: "Don't have an account?",
        have_account: 'Already have an account?',
        register_now: 'Register now',
        login_now: 'Login now',
        premium_required: 'Premium membership required',
        upgrade_to_premium: 'Upgrade to Premium',
        forgot_password: 'Forgot password?',
        password_mismatch: 'Passwords do not match',
        password_too_short: 'Password must be at least 6 characters long',
        upgrade_failed: 'Upgrade failed',
        image_only: 'Please select an image (JPEG, PNG or WebP)',
        file_too_large: 'Image must be max 5MB',
        upload_error: 'Error uploading profile picture'
      },
      profile: {
        title: 'Profile',
        subtitle: 'Your statistics and achievements',
        premium_member: 'Premium Member',
        free_account: 'Free Account',
        upgrade_title: 'Upgrade to Premium',
        upgrade_desc: 'Unlock all features:',
        upgrade_feature1: 'Unlimited access to all 100+ routes',
        upgrade_feature2: 'Create your own routes',
        upgrade_feature3: 'Upload photos in reviews',
        upgrade_feature4: '7-day weather forecast',
        upgrade_feature5: 'Priority support',
        upgrade_button: 'Upgrade now for free (Demo)',
        upgrading: 'Upgrading...',
        upgrade_success: 'Premium successfully activated!',
        total_distance: 'Total Distance',
        total_elevation: 'Elevation Gain',
        total_rides: 'Tours',
        achievements: 'Achievements',
        first_tour: 'First Tour',
        completed: 'Completed',
        reached: 'Reached!',
        demo_mode: 'Demo mode: This is a demo profile. In the full version you can track and sync your real tours.'
      },
      routes: {
        title: 'Routes',
        subtitle: 'Discover the best cycling routes in Scotland',
        create_route: 'Create Own Route',
        filter_show: 'Show Filters',
        filter_hide: 'Hide Filters',
        clear_filters: 'Clear Filters',
        limited_warning_title: 'Only 10 Routes Available (Free Version)',
        limited_warning_text: 'Upgrade to Premium for unlimited access to all 100+ routes!',
        upgrade_now: 'Upgrade Now',
        distance_label: 'Distance',
        elevation_label: 'Elevation Gain',
        show_on_map: 'Show on Map',
        routes_found: 'routes found',
        no_routes: 'No routes found',
        verified: 'Verified',
        child_friendly: 'Child-Friendly',
        child_friendly_only: 'Child-friendly routes only'
      },
      pois: {
        title: 'Points of Interest',
        subtitle: 'Discover interesting places along your route',
        show_on_map: 'Show on Map',
        pois_found: 'POIs found',
        no_pois: 'No POIs found'
      },
      events: {
        title: 'Events',
        subtitle: 'Cycling events and festivals in Scotland',
        upcoming_only: 'Upcoming Only',
        all_events: 'All Events',
        events_found: 'events found',
        no_events: 'No events found',
        free_entry: 'Free Entry',
        from: 'From'
      },
      map: {
        title: 'Map',
        subtitle: 'Interactive map of Scotland',
        show_regions: 'Regions',
        show_routes: 'Routes',
        show_pois: 'POIs',
        legend: 'Legend'
      },
      create_route: {
        title: 'Create Route',
        subtitle: 'Create your own route',
        route_name: 'Route Name',
        description: 'Description',
        distance: 'Distance (km)',
        elevation: 'Elevation Gain (m)',
        duration: 'Duration (hours)',
        save_route: 'Save Route',
        cancel: 'Cancel',
        creating: 'Creating...'
      },
      my_routes: {
        title: 'My Routes',
        subtitle: 'Your saved routes',
        no_routes: 'You haven\'t created any routes yet',
        create_first: 'Create your first route',
        delete: 'Delete',
        edit: 'Edit'
      },
      pricing: {
        title: 'Go Premium',
        subtitle: 'Choose the perfect plan for your Scotland adventure',
        features_title: 'What you get with Premium:',
        feature_1: 'Unlimited access to all 100+ verified routes',
        feature_2: 'Create and share your own routes',
        feature_3: 'Upload photos in reviews',
        feature_4: '7-day weather forecast for all regions',
        feature_5: 'Offline maps for download',
        feature_6: 'Priority support',
        month: 'Month',
        months: 'Months',
        lifetime_label: 'Forever',
        save: 'Save',
        bestseller: 'Bestseller',
        early_bird: 'Early Bird',
        choose_plan: 'Choose Plan',
        current_plan: 'Current Plan',
        upgrading: 'Activating...',
        already_premium: 'You are already a Premium member!',
        upgrade_success: 'Premium successfully activated! 🎉',
        upgrade_failed: 'Upgrade failed. Please try again.',
        faq_title: 'Frequently Asked Questions',
        faq_1_q: 'Can I cancel anytime?',
        faq_1_a: 'Yes, you can cancel anytime. Your Premium access remains active until the end of the paid period.',
        faq_2_q: 'What happens after my subscription expires?',
        faq_2_a: 'After expiration, you can still use the app with limited access (10 routes). You can upgrade to Premium again anytime.',
        faq_3_q: 'Is the Lifetime offer really forever?',
        faq_3_a: 'Yes! One-time payment, lifetime access to all Premium features. The Early Bird offer is only available for the first 500 users.',
        demo_note: 'Demo mode: This is a demo version. In the full version, payment processing (e.g., Stripe) would be integrated here.'
      },
      payment: {
        processing: 'Processing payment...',
        success_title: 'Payment Successful! 🎉',
        success_message: 'Welcome to PedalScot Premium! Your account has been successfully upgraded.',
        whats_next: 'What\'s now available:',
        feature_unlocked_1: 'All 100+ premium routes unlocked',
        feature_unlocked_2: 'Create and share your own routes',
        feature_unlocked_3: 'Upload photos in reviews',
        feature_unlocked_4: '7-day weather forecast available',
        go_to_profile: 'Go to My Profile',
        confirmation_email: 'A confirmation email has been sent to your address.'
      },
      knowledge: {
        title: 'Knowledge',
        subtitle: 'Everything for your perfect Scotland tour',
        all: 'All',
        guides: 'Guides',
        regions: 'Regions',
        checklists: 'Checklists',
        stories: 'Stories',
        learn_more: 'Learn more',
        download_pdf: 'Download PDF',
        guide_equipment: 'Equipment for Cycling Tours',
        guide_equipment_desc: 'Everything you need for your Scotland tour',
        guide_technique: 'Riding Technique',
        guide_technique_desc: 'Tips for beginners and advanced riders',
        guide_safety: 'Safety',
        guide_safety_desc: 'Stay safe in Scotland',
        guide_traffic: 'UK Traffic Rules',
        guide_traffic_desc: 'Left-hand traffic and Scottish peculiarities',
        guide_ebike: 'E-Bike Basics',
        guide_ebike_desc: '25 km/h and 45 km/h - What you need to know',
        region_highlands: 'Highlands',
        region_highlands_desc: 'Dramatic mountain landscapes and NC500',
        region_islands: 'Islands (Skye, Orkney, Shetland)',
        region_islands_desc: 'Island adventures with ferries & extreme wind',
        region_lowlands: 'Lowlands & Borders',
        region_lowlands_desc: 'Rolling hills and historic sites',
        region_edinburgh: 'Edinburgh & Fife',
        region_edinburgh_desc: 'Capital and coastal routes',
        season_may_sep: 'May - September',
        season_jun_aug: 'June - August',
        season_apr_oct: 'April - October',
        season_year_round: 'Year-round',
        checklist_packing: 'Packing List Multi-Day Tours',
        checklist_packing_desc: 'Complete list for 3-7 day tours',
        checklist_bike: 'Bike Check Before Tour',
        checklist_bike_desc: 'Safety check in 10 steps',
        checklist_emergency: 'Emergency Checklist',
        checklist_emergency_desc: 'Important numbers and first aid',
        story_nc500: 'NC500 in 10 Days',
        story_nc500_desc: '850 km through the most beautiful Highlands',
        story_skye: 'Isle of Skye by E-Bike',
        story_skye_desc: 'Magical island without breaking a sweat',
        story_whisky: 'Whisky Trail by Bike',
        story_whisky_desc: 'Speyside distilleries by bike',
        stats_guides: 'Guides',
        stats_regions: 'Regions',
        stats_checklists: 'Checklists',
        stats_stories: 'Stories'
      },
      calculator: {
        title: 'E-Bike Range Calculator',
        battery_capacity: 'Battery Capacity (kWh)',
        current_charge: 'Current Charge (%)',
        elevation: 'Elevation (m)',
        wind_speed: 'Wind Speed (km/h)',
        rider_weight: 'Rider Weight (kg)',
        assistance_level: 'Assistance Level (1-3)',
        calculate: 'Calculate Range',
        calculating: 'Calculating...',
        result_title: 'Result',
        estimated_range: 'Estimated Range',
        can_complete: 'Route Completable',
        cannot_complete: 'Route too long for current charge',
        remaining_charge: 'Remaining Charge',
        yes: 'Yes',
        no: 'No',
        warning: 'Warning',
        charging_needed: 'Charging Needed'
      },
      guide: {
        page_title: 'Scotland Guide for Cyclists',
        page_subtitle: 'Everything you need to know for your cycling tour in Scotland',
        overview: {
          title: 'Overview',
          important: 'Important',
          drive_left: 'In Scotland, drive on the left! Islands, passes, and single-track roads with passing places are typical.',
          best_season_title: 'Best Travel Season',
          best_season_optimal: 'May–June and September–October are optimal',
          best_season_summer: 'Summer is warmer, but midges are active',
          best_season_west: 'West is wetter than East',
          best_season_wind: 'Wind often comes from southwest',
          tip: 'Tip',
          tip_text: 'Plan shorter stages against the wind and factor in rainy and windy days.'
        },
        legal: {
          title: 'Law & Rules',
          ebike_title: 'E-Bike Regulation (EAPC)',
          ebike_power: 'Max. 250W motor',
          ebike_speed: 'Assistance up to 25 km/h',
          ebike_age: 'From 14 years',
          ebike_license: 'No registration or insurance required',
          equipment_title: 'Mandatory Equipment',
          equipment_lights: 'Lights in darkness: White front, red rear',
          equipment_reflectors: 'Reflectors: Red rear reflector, pedal reflectors recommended',
          equipment_helmet: 'Helmet: Not mandatory, but strongly recommended',
          access_title: 'Scottish Outdoor Access Code',
          access_text: 'In Scotland, you have legally secured access to nature if you behave responsibly. This also applies to cycling!',
          access_link: 'Scottish Outdoor Access Code'
        },
        safety: {
          title: 'Safety & Health',
          single_track_warning: 'Single-Track Roads: Drive anticipatively, wait early in passing places, give hand signals and thank drivers!',
          ticks_title: 'Ticks & Lyme Disease',
          ticks_clothing: 'Use long clothing and repellent',
          ticks_check: 'Daily check for ticks',
          ticks_removal: 'Remove ticks correctly with tweezers',
          ticks_symptoms: 'See a doctor immediately if you notice erythema or flu-like symptoms',
          emergency_title: 'Emergency',
          emergency_text: '999 or 112 | Medical advice: NHS 24 via 111',
          traffic_title: 'Traffic Safety',
          traffic_distance: 'Respect bus/truck overtaking distances',
          traffic_lights: 'Only ride at night with full lighting',
          traffic_groups: 'In groups: Two abreast is allowed, but single up when needed'
        },
        weather: {
          title: 'Weather & Midges',
          temp_title: 'Temperatures & Climate',
          temp_warmest: 'Warmest months: June–August',
          temp_east: 'East side: Drier and brighter',
          temp_west: 'West coast: Wetter, but more spectacular',
          midges_warning: 'Midges (biting insects):',
          midges_season: 'Peak season: May–September',
          midges_worst: 'Worst during calm evenings',
          midges_protection: 'Bring midge net and repellent!',
          midges_forecast: 'Scottish Midge Forecast'
        },
        transport: {
          title: 'Transport with Bike',
          train_title: 'Train (ScotRail)',
          train_bikes_free: 'Bikes mostly free with reservation',
          train_ebikes: 'E-bikes allowed',
          train_scooters: 'E-scooters prohibited',
          train_booking: 'Limited spaces per train – book early!',
          ferry_title: 'Ferries',
          ferry_calmac: 'CalMac (Hebrides):',
          ferry_calmac_bikes: 'Bikes are taken',
          ferry_calmac_booking: 'Reservation for passenger travel strongly recommended',
          ferry_calmac_spaces: 'Bike spaces usually sufficient',
          ferry_northlink: 'NorthLink (Orkney/Shetland):',
          ferry_northlink_booking: 'Bike transport possible, book ahead',
          bus_title: 'Long-distance Bus (Citylink/Stagecoach)',
          bus_storage: 'Bikes sometimes in luggage compartment',
          bus_sock: 'Often "Bike-Sock"/cover required',
          bus_limited: 'Limited spaces',
          bus_ebikes: 'E-bikes mostly excluded – check beforehand!',
          flight_warning: 'Flight: E-bike batteries (>160 Wh) are not allowed on passenger aircraft. Solution: Rent e-bike locally or ship battery separately via hazardous goods freight (complicated/expensive).'
        },
        charging: {
          title: 'Charging & Range',
          public_title: 'Public Charging Points',
          public_text: 'Public e-bike charging points exist sporadically, often Bosch "PowerStations" at cafés on NCN routes. Not widespread!',
          tips_title: 'Tips:',
          tips_charger: 'Always bring your own charger',
          tips_accommodation: 'Ask accommodations about charging options in advance',
          tips_plug: 'Get UK plug (Type G)',
          tips_powerbank: 'Powerbank for GPS/lights',
          range_title: 'Range Factors',
          range_cold: 'Cold reduces range',
          range_wind: 'Wind can significantly affect range',
          range_terrain: 'Rough terrain increases consumption',
          recommendation: 'Recommendation: Plan for "Eco" mode sections and bring a spare battery if possible.'
        },
        camping: {
          title: 'Wild Camping & Bothies',
          wild_title: 'Wild Camping',
          wild_intro: 'Wild camping with a tent in small numbers and only 2–3 nights per spot is allowed if you:',
          wild_distance: 'Keep distance from buildings/pastures',
          wild_trace: 'Leave no trace',
          wild_code: 'Follow the Access Code',
          wild_fire: 'Avoid fires',
          wild_trash: 'Take your trash with you',
          lomond_warning: 'Loch Lomond & The Trossachs: Note seasonal zones with permit requirement!',
          bothies_title: 'Bothies (Mountain Shelters)',
          bothies_intro: 'Bothies are simple huts for emergency and bad weather situations. Follow the "Bothy Code":',
          bothies_groups: 'No large groups',
          bothies_clean: 'Leave the hut clean',
          bothies_respect: 'Respect other users',
          bothies_no_booking: 'No reservations possible',
          bothies_link: 'Mountain Bothies Association'
        },
        routes: {
          title: 'Top Routes',
          hebridean_title: 'Hebridean Way',
          hebridean_stats: '~300 km | Outer Hebrides | Many ferries',
          hebridean_desc: 'Pure landscape, little traffic, strong winds. Prefer tailwind route (North→South)!',
          caledonia_title: 'The Caledonia Way (NCN 78)',
          caledonia_stats: 'Oban–Fort William–Inverness | Great Glen',
          caledonia_desc: 'Mix of quiet roads and canal towpaths. E-bike friendly and scenically spectacular.',
          deeside_title: 'Deeside Way (NCN 195)',
          deeside_stats: 'Aberdeen–Ballater | Old railway line',
          deeside_desc: 'Family-friendly, flat, well-developed. Perfect for beginners.',
          speyside_title: 'Speyside Way',
          speyside_stats: 'Fochabers–Ballindalloch & Nethy Bridge–Aviemore',
          speyside_desc: 'Sections suitable for cycling. Whisky distilleries along the route!',
          mtb_title: 'MTB/Gravel Centers',
          mtb_glentress: 'Glentress/Innerleithen (Tweed Valley, 7stanes): Wide trail spectrum',
          mtb_nevis: 'Nevis Range, Fort William: Gondola uplift, World Cup downhill',
          mtb_7stanes: 'Other 7stanes: Kirroughtree, Ae, Mabie, Dalbeattie'
        },
        equipment: {
          title: 'Equipment & Setup',
          tires_title: 'Tires',
          tires_tour: 'Tour: 32–38mm with puncture protection',
          tires_gravel: 'Gravel/MTB: 40–50mm+, robust',
          weather_title: 'Weather Equipment',
          weather_jacket: '3-layer rain jacket (waterproof & breathable)',
          weather_overshoes: 'Overshoes',
          weather_gloves: 'Waterproof gloves',
          weather_bags: 'Spare clothing in waterproof bags',
          electronics_title: 'Electronics',
          electronics_lights: 'Fixed lights (front & rear)',
          electronics_charger: 'USB charger + powerbank',
          electronics_gps: 'GPS device or smartphone with offline maps',
          ebike_title: 'E-Bike Specific',
          ebike_charger: '4A charger with UK plug (Type G)',
          ebike_cold: 'Battery protection in cold',
          ebike_spare: 'Spare battery if possible',
          ebike_insulation: 'Insulation cover for battery in winter',
          health_title: 'Health',
          health_net: 'Midge net',
          health_repellent: 'Repellent (DEET)',
          health_tick: 'Tick card/tweezers',
          health_first_aid: 'First aid kit'
        },
        accommodation: {
          title: 'Accommodation',
          hostels_title: 'Hostelling Scotland',
          hostels_intro: 'Often with bike room, some with bike wash and drying. Examples:',
          hostels_oban: 'Oban',
          hostels_aviemore: 'Aviemore',
          hostels_port: 'Port Charlotte',
          hostels_lochranza: 'Lochranza',
          hostels_tip: 'Always clarify storage and charging rules in advance!',
          networks_title: 'Networks',
          networks_scottish: 'Scottish Hostels: "cycle friendly" filter',
          networks_independent: 'Independent Hostels: Bike-friendly accommodations',
          networks_bnb: 'B&Bs: Many offer bike storage and drying',
          hostels_link: 'Hostelling Scotland'
        },
        planning: {
          title: 'Planning & Booking',
          accommodation_title: 'Accommodation',
          accommodation_best: 'Best Platforms',
          hostelworld_title: 'Hostelworld',
          hostelworld_desc: 'Largest selection, strong app, many reviews',
          hostelling_title: 'Hostelling Scotland',
          hostelling_desc: 'Nationwide network, direct booking with best price guarantee',
          alternatives_title: 'Cheaper & Fairer Alternatives',
          direct_booking_title: 'Book Directly',
          direct_booking_desc: 'VisitScotland recommends direct booking – often fairest solution for properties. Find official link via Google Hotels and click "Website".',
          hostelz_title: 'Hostelz.com',
          hostelz_desc: 'Price comparison without OTA bias. Shows prices from Hostelworld, Booking, etc.',
          dorms_title: 'Dorms.com',
          dorms_desc: 'Additional hostel option',
          booking_note: 'Note: Booking.com works with ~15% commission. Direct booking avoids these costs and supports properties directly.',
          workflow_title: 'Practical Workflow (3 Steps)',
          workflow_step1: 'Filter on Hostelworld, check map, read reviews',
          workflow_step2: 'Search property on Hostelling Scotland or via Google Hotels and book directly if possible',
          workflow_step3: 'Quick price check with Hostelz.com',
          workflow_result: 'This covers selection, price, and fairness.',
          flights_title: 'Flights',
          flights_best: 'Best Flight Search Engines',
          skyscanner_title: 'Skyscanner',
          skyscanner_desc: '"Everywhere" search, month view, price alerts',
          google_flights_title: 'Google Flights',
          google_flights_desc: 'Transparency, calendar, price tracking. Often direct link to airline.',
          kayak_title: 'KAYAK & momondo',
          kayak_desc: 'Additional meta-search for cross-checking',
          airlines_title: 'Book Directly with Airlines',
          airlines_desc: 'Better customer service and clear baggage rules',
          airlines_list: 'Loganair, easyJet, Ryanair, British Airways',
          flights_workflow_title: 'Recommended Workflow (3 Steps)',
          flights_step1: 'Search on Skyscanner, be flexible with month view/"Everywhere"',
          flights_step2: 'Cross-check route on Google Flights and set price alert',
          flights_step3: 'Book at best option directly with airline or cheapest platform',
          visit_website: 'Visit Website'
        },
        footer_tip: 'Tip: Book ferries (CalMac/NorthLink) and ScotRail bike spaces early. Check weather forecast and midge prediction before each tour!'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    lng: localStorage.getItem('language') || 'de',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
